import { IChatGuest } from '@commons/chat-assistance/models/chat-guest';

export class ActiveRoom {
  public roomId: string;
  public toGuests: IChatGuest[];

  constructor(roomId: string, toGuests: IChatGuest[]) {
    this.roomId = roomId;
    this.toGuests = toGuests;
  }
}
